var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmaplanEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.498 3.97682C7.17228 3.97682 4.47656 6.67276 4.47656 9.99818C4.47656 10.083 4.47862 10.1675 4.48196 10.2513H4.47656V19.9978H7.56153V15.2554C7.56153 15.2554 7.56333 15.2565 7.5641 15.257V9.83246H7.56795C7.64555 8.31762 8.89834 7.11314 10.4325 7.11314C11.9666 7.11314 13.3008 8.39726 13.3008 9.98148C13.3008 11.5657 12.0167 12.8498 10.4325 12.8498C9.78989 12.8498 9.19664 12.6384 8.71823 12.2815V15.7518C9.28065 15.9255 9.87853 16.0193 10.498 16.0193C13.8237 16.0193 16.5194 13.3233 16.5194 9.99792C16.5194 6.67251 13.8234 3.97656 10.498 3.97656V3.97682Z",
    fill: "url(#paint0_linear_30023_81495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.97702 0 0.5 4.47697 0.5 9.99989V19.9998H3.40229L3.3676 10.1052V9.99989V9.7296V9.70051C3.50969 5.88668 6.65143 2.86757 10.5 2.86757C14.3486 2.86757 17.6324 6.06067 17.6324 9.99989C17.6324 13.9391 14.4393 17.1322 10.5 17.1322C9.88439 17.1322 9.28729 17.0541 8.71767 16.9074V19.8407C9.29602 19.9448 9.89159 19.9998 10.5 19.9998C16.0227 19.9998 20.5 15.5228 20.5 9.99989C20.5 4.47697 16.0227 0 10.5 0Z",
    fill: "url(#paint1_linear_30023_81495)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30023_81495",
    x1: 16.498,
    y1: 11.9984,
    x2: 2.97167,
    y2: 11.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.618133,
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11723B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30023_81495",
    x1: 13.125,
    y1: 11.8499,
    x2: 0.5,
    y2: 11.6249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#11723B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaplanEmail);
export default __webpack_public_path__ + "static/media/pharmaplanEmail.6fe716f37d4bb3a180e57ae23d065795.svg";
export { ForwardRef as ReactComponent };